(function() {
    'use strict';
    angular.module('app').factory('LoginFactory',
        ['$log',
            '$q',
            'AprimaRestangular',
            'Bridge',
            'CurrentUserRepository',
            'LocalStorageRepository',
            'aprgettext',
            'ServerInfoRepository',
            'SessionService',
            'VersionService',
            'MultipleUserAccountsError',
            function ($log,
                      $q,
                      AprimaRestangular,
                      Bridge,
                      CurrentUserRepository,
                      LocalStorageRepository,
                      gettext,
                      ServerInfoRepository,
                      SessionService,
                      VersionService,
                      MultipleUserAccountsError) {

                var loginErrorCodes = {
                    UnknownError: 1,
                    InvalidRequest: 2,
                    UnknownClientId: 4,
                    LoginFailed: 8,
                    NotMobileUser: 16,
                    InactiveUser: 32,
                    NotAllowedToLogin: 64,
                    PrmVersionUnsupported: 128,
                    MultipleUserAccounts: 256
                };

                function updateVersionInfo(userLoginInfo) {
                    if (userLoginInfo && userLoginInfo.ProductVersions) {
                        if (userLoginInfo.ProductVersions.PrmAssemblyVersion) {
                            ServerInfoRepository.setPrmAssemblyVersion(userLoginInfo.ProductVersions.PrmAssemblyVersion);
                        }
                        if (userLoginInfo.ProductVersions.PrmDatabaseVersion) {
                            ServerInfoRepository.setPrmDatabaseVersion(userLoginInfo.ProductVersions.PrmDatabaseVersion);
                        }
                        if (userLoginInfo.ProductVersions.PrmDatabaseBuild) {
                            ServerInfoRepository.setPrmDatabaseBuild(userLoginInfo.ProductVersions.PrmDatabaseBuild);
                        }
                        if (userLoginInfo.ProductVersions.AppServiceVersion) {
                            ServerInfoRepository.setMobileAssemblyVersion(userLoginInfo.ProductVersions.AppServiceVersion);
                        }
                        if (userLoginInfo.SupportedFeatures) {
                            ServerInfoRepository.setSupportedFeatures(userLoginInfo.SupportedFeatures);
                        }
                    }
                }

                function postLogin(clientURL, _clientId, _username, _password, userId, clientFeatures) {
                    var restangular = AprimaRestangular.get('facility');
                    return restangular.one('login').customPOST({
                        Username: _username,
                        Password: _password,
                        ClientId: _clientId,
                        DeviceId: LocalStorageRepository.getDeviceId(),
                        UserId: userId,
                        ClientFeatures: clientFeatures
                    }).then(function (userLoginInfo) {
                        var authToken = userLoginInfo.JsonWebToken,
                            msg;
                        return VersionService.checkVersions(userLoginInfo.SupportedApiVersions, userLoginInfo.MinClientVersion).then(function (validationSuccesful) {
                            if (validationSuccesful === false) {
                                return $q.reject(new Error(gettext('Client Version not compatible with api server. Please update your app.')));
                            }
                            if (!userLoginInfo) {
                                msg = gettext('Unexpected null result from server in Login');
                            } else if (!userLoginInfo.DeviceId) {
                                return $q.reject(new Error(gettext('Client Version not compatible with api server. Please update your app.')));
                            }
                            if (msg) {
                                $log.warn(msg);
                                Bridge.trackException(msg);
                            }
                            LocalStorageRepository.setIsActiveDirectoryUser(userLoginInfo.IsActiveDirectoryUser);
                            LocalStorageRepository.setDeviceId(userLoginInfo.DeviceId);
                            LocalStorageRepository.setJsonWebToken(authToken);
                            LocalStorageRepository.setUserName(_username);
                            LocalStorageRepository.setUserFullName(userLoginInfo.FirstName + ' ' + userLoginInfo.LastName);
                            LocalStorageRepository.setUserID(userLoginInfo.Id);
                            updateVersionInfo(userLoginInfo);
                            SessionService.setNewPasswordRequired(userLoginInfo.IsNewPasswordRequired);
                            Bridge.changeUserInfo(authToken, clientURL, userLoginInfo.Id);

                            CurrentUserRepository.setActiveUser(userLoginInfo.Id, userLoginInfo.FirstName, userLoginInfo.LastName, _username ,userLoginInfo.IsActiveDirectoryUser);

                            return $q.when(userLoginInfo);
                        });
                    }).catch(function(response)
                    {
                        var msg = gettext('login error'),
                            errorCode = null;
                        if (response.status === 401) {
                            msg = gettext('Invalid username or password');

                            errorCode = angular.isNumber(response.data.ErrorCode) ? response.data.ErrorCode : 0;

                            if(errorCode & loginErrorCodes.MultipleUserAccounts) {
                                var error = new MultipleUserAccountsError(response.data.UserOptions);
                                return $q.reject(error);
                            }

                            if (errorCode & loginErrorCodes.UnknownClientId) {
                                msg = gettext('Unknown clientId (' + _clientId + ').');
                            } else if (errorCode & loginErrorCodes.LoginFailed) {
                                msg = gettext('Invalid username or password');
                            } else if (errorCode & loginErrorCodes.InactiveUser) {
                                msg = gettext('This user account is not active and cannot login.');
                            } else if (errorCode & loginErrorCodes.NotAllowedToLogin) {
                                msg = gettext('This user account does not have the required permissions to login.');
                            } else if (errorCode & loginErrorCodes.PrmVersionUnsupported) {
                                msg = gettext('PRM version out of date.  Please contact customer support about upgrading.');
                            }
                        }
                        return $q.reject(new Error(msg));
                    });


                }

                return {
                    postLogin : postLogin
                };
            }]);
})();
